/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListEmploymentsForPosRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {ListEmploymentsForPosResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const listEmploymentsForPos = (request: ListEmploymentsForPosRequest, options?: CashRequestOptions) => post<ListEmploymentsForPosRequest, ListEmploymentsForPosResponse>("/2.0/cash/list-employments-for-pos", request, {...options, rejectOnError: true })